export interface ApiResponse<T> {
	status: number
	success: boolean
	payload: T
}

export class ApiError extends Error {
	constructor(
		public status: number,
		public errors: { msg: string; path?: string }[],
	) {
		super(errors.map(e => e.msg).join(', '))
	}
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
	const res = await fetch(path, {
		headers: { 'Content-Type': 'application/json', ...options?.headers },
		...options,
	})

	const data: ApiResponse<T> = await res.json()

	if (!data.success) {
		const errors = (data.payload as any)?.errors ?? [{ msg: String(data.payload) }]
		throw new ApiError(data.status, errors)
	}

	return data.payload
}

export async function apiGet<T>(path: string): Promise<T> {
	return request<T>(path)
}

export async function apiPost<T>(path: string, body?: unknown): Promise<T> {
	return request<T>(path, {
		method: 'POST',
		body: body !== undefined ? JSON.stringify(body) : undefined,
	})
}

export async function apiPatch<T>(path: string, body: unknown): Promise<T> {
	return request<T>(path, {
		method: 'PATCH',
		body: JSON.stringify(body),
	})
}

export async function apiDelete<T>(path: string): Promise<T> {
	return request<T>(path, { method: 'DELETE' })
}
